var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from 'react';
import { UXPContext } from '@core/context/Context';
import { SlideInPanel } from '@widget/other/SlideInPanel';
import Button from '@widget/buttons/Button';
import AsyncButton from '@widget/buttons/AsyncButton';
import IconButton from '@widget/buttons/IconButton';
import { Dropdown } from '@widget/popups/Dropdown';
import ActionsListComponent from '../Common/ActionListComponent';
export const PipelineRefineModal = ({ show, pipeline, onClose, onApply, isPredefined, onSaveAsQuery, onSaveChangesToQuery }) => {
    const context = useContext(UXPContext);
    const [QueryBuilder, setQueryBuilder] = useState(null);
    const [applyError, setApplyError] = useState(null);
    const queryBuilderRef = useRef(null);
    const menuRef = useRef(null);
    useEffect(() => {
        if (!show)
            return;
        setApplyError(null);
        setQueryBuilder(() => { var _a, _b; return (_b = (_a = window.QueryBuilderComponents) === null || _a === void 0 ? void 0 : _a.QueryBuilder) !== null && _b !== void 0 ? _b : null; });
    }, [show]);
    // Validate + return the current edited pipeline (with schema), or null (setting an error) if invalid.
    function getCurrentQuery() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            setApplyError(null);
            try {
                const result = yield ((_a = queryBuilderRef.current) === null || _a === void 0 ? void 0 : _a.onSave());
                if (!(result === null || result === void 0 ? void 0 : result.isValid) || !(result === null || result === void 0 ? void 0 : result.query)) {
                    setApplyError((result === null || result === void 0 ? void 0 : result.error) || context.$L('uxp-core.text.advanced-filter-no-results'));
                    return null;
                }
                return { query: result.query, schema: result.schema };
            }
            catch (e) {
                setApplyError(context.$L('uxp-core.text.advanced-filter-no-results'));
                return null;
            }
        });
    }
    function handleApply() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield getCurrentQuery();
            if (!res)
                return;
            onApply(res.query);
            onClose();
        });
    }
    const isReady = !!QueryBuilder && !!pipeline;
    const saveActions = [];
    if (isPredefined && onSaveChangesToQuery) {
        saveActions.push({
            label: context.$L('uxp-core.text.save-changes-to-query'),
            icon: 'fal save',
            onClick: () => __awaiter(void 0, void 0, void 0, function* () { const r = yield getCurrentQuery(); if (r)
                onSaveChangesToQuery(r.query, r.schema); }),
        });
    }
    if (onSaveAsQuery) {
        saveActions.push({
            label: context.$L('uxp-core.text.save-as-new-query'),
            icon: 'fal plus',
            onClick: () => __awaiter(void 0, void 0, void 0, function* () { const r = yield getCurrentQuery(); if (r)
                onSaveAsQuery(r.query, r.schema); }),
        });
    }
    return (_jsx(SlideInPanel, { isOpen: show, onClose: onClose, direction: 'right', children: _jsxs("div", { className: "uxpcore_osc__refine_panel", children: [_jsxs("div", { className: "uxpcore_osc__refine_panel__header", children: [_jsx("span", { className: "uxpcore_osc__refine_panel__title", children: context.$L('uxp-core.text.refine-pipeline') }), _jsxs("div", { className: "uxpcore_osc__refine_panel__header-actions", children: [_jsx(Button, { title: context.$L('uxp-core.text.cancel'), onClick: onClose, variant: 'secondary', size: 'small' }), _jsx(AsyncButton, { title: context.$L('uxp-core.text.apply-changes'), loadingTitle: context.$L('uxp-core.text.applying'), onClick: handleApply, variant: 'primary', disabled: !isReady }), isReady && saveActions.length > 0 && (_jsx(Dropdown, { ref: menuRef, position: "bottom-right", trigger: _jsx(IconButton, { icon: "fal ellipsis-h", tooltip: context.$L('uxp-core.text.more-actions'), variant: 'secondary', mode: 'filled' }), content: _jsx(ActionsListComponent, { actions: saveActions, parentDropdownRef: menuRef }) }))] })] }), applyError && (_jsx("div", { className: "uxpcore_osc__refine_panel__error", children: applyError })), _jsxs("div", { className: "uxpcore_osc__refine_panel__body", children: [!QueryBuilder && (_jsx("div", { className: "uxpcore_osc__refine_panel__unavailable", children: context.$L('uxp-core.text.query-builder-unavailable') })), QueryBuilder && pipeline && (_jsx(QueryBuilder, { initialQuery: pipeline, uxpContext: context, ref: queryBuilderRef }))] })] }) }));
};
